<template>
  <ul class="Editor-Smiles-List">
    <li class="Editor-Smiles-List__item">💘</li>
    <li class="Editor-Smiles-List__item">💝</li>
    <li class="Editor-Smiles-List__item">💖</li>
    <li class="Editor-Smiles-List__item">💗</li>
    <li class="Editor-Smiles-List__item">💓</li>
    <li class="Editor-Smiles-List__item">💞</li>
    <li class="Editor-Smiles-List__item">💕</li>
    <li class="Editor-Smiles-List__item">💟</li>
    <li class="Editor-Smiles-List__item">❣️</li>
    <li class="Editor-Smiles-List__item">💔</li>
    <li class="Editor-Smiles-List__item">❤️</li>
    <li class="Editor-Smiles-List__item">❤️</li>
    <li class="Editor-Smiles-List__item">❤️</li>
    <li class="Editor-Smiles-List__item">🧡</li>
    <li class="Editor-Smiles-List__item">💛</li>
    <li class="Editor-Smiles-List__item">💚</li>
    <li class="Editor-Smiles-List__item">💙</li>
    <li class="Editor-Smiles-List__item">💜</li>
    <li class="Editor-Smiles-List__item">🤎</li>
    <li class="Editor-Smiles-List__item">🖤</li>
    <li class="Editor-Smiles-List__item">🤍</li>
    <li class="Editor-Smiles-List__item">💯</li>
    <li class="Editor-Smiles-List__item">💢</li>
    <li class="Editor-Smiles-List__item">💬</li>
    <li class="Editor-Smiles-List__item">👁️‍🗨️</li>
    <li class="Editor-Smiles-List__item">🗨️</li>
    <li class="Editor-Smiles-List__item">🗯️</li>
    <li class="Editor-Smiles-List__item">💭</li>
    <li class="Editor-Smiles-List__item">💤</li>
    <li class="Editor-Smiles-List__item">💮</li>
    <li class="Editor-Smiles-List__item">♨️</li>
    <li class="Editor-Smiles-List__item">💈</li>
    <li class="Editor-Smiles-List__item">🛑</li>
    <li class="Editor-Smiles-List__item">🕛</li>
    <li class="Editor-Smiles-List__item">🕐</li>
    <li class="Editor-Smiles-List__item">🕜</li>
    <li class="Editor-Smiles-List__item">🕝</li>
    <li class="Editor-Smiles-List__item">🕞</li>
    <li class="Editor-Smiles-List__item">🕟</li>
    <li class="Editor-Smiles-List__item">🕠</li>
    <li class="Editor-Smiles-List__item">🕡</li>
    <li class="Editor-Smiles-List__item">🕢</li>
    <li class="Editor-Smiles-List__item">🕣</li>
    <li class="Editor-Smiles-List__item">🕤</li>
    <li class="Editor-Smiles-List__item">🕥</li>
    <li class="Editor-Smiles-List__item">🕦</li>
    <li class="Editor-Smiles-List__item">🌀</li>
    <li class="Editor-Smiles-List__item">♠️</li>
    <li class="Editor-Smiles-List__item">♥️</li>
    <li class="Editor-Smiles-List__item">♦️</li>
    <li class="Editor-Smiles-List__item">♣️</li>
    <li class="Editor-Smiles-List__item">🃏</li>
    <li class="Editor-Smiles-List__item">🀄</li>
    <li class="Editor-Smiles-List__item">🎴</li>
    <li class="Editor-Smiles-List__item">🔇</li>
    <li class="Editor-Smiles-List__item">🔈</li>
    <li class="Editor-Smiles-List__item">🔉</li>
    <li class="Editor-Smiles-List__item">🔊</li>
    <li class="Editor-Smiles-List__item">📢</li>
    <li class="Editor-Smiles-List__item">📣</li>
    <li class="Editor-Smiles-List__item">📯</li>
    <li class="Editor-Smiles-List__item">🔔</li>
    <li class="Editor-Smiles-List__item">🔕</li>
    <li class="Editor-Smiles-List__item">🎵</li>
    <li class="Editor-Smiles-List__item">🎶</li>
    <li class="Editor-Smiles-List__item">💹</li>
    <li class="Editor-Smiles-List__item">🏧</li>
    <li class="Editor-Smiles-List__item">🚮</li>
    <li class="Editor-Smiles-List__item">🚰</li>
    <li class="Editor-Smiles-List__item">♿</li>
    <li class="Editor-Smiles-List__item">🚹</li>
    <li class="Editor-Smiles-List__item">🚺</li>
    <li class="Editor-Smiles-List__item">🚻</li>
    <li class="Editor-Smiles-List__item">🚼</li>
    <li class="Editor-Smiles-List__item">🚾</li>
    <li class="Editor-Smiles-List__item">⚠️</li>
    <li class="Editor-Smiles-List__item">🚸</li>
    <li class="Editor-Smiles-List__item">⛔</li>
    <li class="Editor-Smiles-List__item">🚫</li>
    <li class="Editor-Smiles-List__item">🚳</li>
    <li class="Editor-Smiles-List__item">🚭</li>
    <li class="Editor-Smiles-List__item">🚯</li>
    <li class="Editor-Smiles-List__item">🚱</li>
    <li class="Editor-Smiles-List__item">🚷</li>
    <li class="Editor-Smiles-List__item">📵</li>
    <li class="Editor-Smiles-List__item">🔞</li>
    <li class="Editor-Smiles-List__item">☢️</li>
    <li class="Editor-Smiles-List__item">☣️</li>
    <li class="Editor-Smiles-List__item">⬆️</li>
    <li class="Editor-Smiles-List__item">↗️</li>
    <li class="Editor-Smiles-List__item">➡️</li>
    <li class="Editor-Smiles-List__item">↘️</li>
    <li class="Editor-Smiles-List__item">⬇️</li>
    <li class="Editor-Smiles-List__item">↙️</li>
    <li class="Editor-Smiles-List__item">⬅️</li>
    <li class="Editor-Smiles-List__item">↖️</li>
    <li class="Editor-Smiles-List__item">↩️</li>
    <li class="Editor-Smiles-List__item">↪️</li>
    <li class="Editor-Smiles-List__item">⤴️</li>
    <li class="Editor-Smiles-List__item">⤵️</li>
    <li class="Editor-Smiles-List__item">🔃</li>
    <li class="Editor-Smiles-List__item">🔄</li>
    <li class="Editor-Smiles-List__item">🔙</li>
    <li class="Editor-Smiles-List__item">🔚</li>
    <li class="Editor-Smiles-List__item">🔛</li>
    <li class="Editor-Smiles-List__item">🔜</li>
    <li class="Editor-Smiles-List__item">🔝</li>
    <li class="Editor-Smiles-List__item">🛐</li>
    <li class="Editor-Smiles-List__item">⚛️</li>
    <li class="Editor-Smiles-List__item">🕉️</li>
    <li class="Editor-Smiles-List__item">✡️</li>
    <li class="Editor-Smiles-List__item">☸️</li>
    <li class="Editor-Smiles-List__item">☯️</li>
    <li class="Editor-Smiles-List__item">✝️</li>
    <li class="Editor-Smiles-List__item">☦️</li>
    <li class="Editor-Smiles-List__item">☪️</li>
    <li class="Editor-Smiles-List__item">☮️</li>
    <li class="Editor-Smiles-List__item">🕎</li>
    <li class="Editor-Smiles-List__item">🔯</li>
    <li class="Editor-Smiles-List__item">♈</li>
    <li class="Editor-Smiles-List__item">♉</li>
    <li class="Editor-Smiles-List__item">♊</li>
    <li class="Editor-Smiles-List__item">♋</li>
    <li class="Editor-Smiles-List__item">♌</li>
    <li class="Editor-Smiles-List__item">♍</li>
    <li class="Editor-Smiles-List__item">♎</li>
    <li class="Editor-Smiles-List__item">♏</li>
    <li class="Editor-Smiles-List__item">♐</li>
    <li class="Editor-Smiles-List__item">♑</li>
    <li class="Editor-Smiles-List__item">♒</li>
    <li class="Editor-Smiles-List__item">♓</li>
    <li class="Editor-Smiles-List__item">⛎</li>
    <li class="Editor-Smiles-List__item">🔀</li>
    <li class="Editor-Smiles-List__item">🔁</li>
    <li class="Editor-Smiles-List__item">🔂</li>
    <li class="Editor-Smiles-List__item">▶️</li>
    <li class="Editor-Smiles-List__item">⏩</li>
    <li class="Editor-Smiles-List__item">⏭️</li>
    <li class="Editor-Smiles-List__item">⏯️</li>
    <li class="Editor-Smiles-List__item">◀️</li>
    <li class="Editor-Smiles-List__item">⏪</li>
    <li class="Editor-Smiles-List__item">⏮️</li>
    <li class="Editor-Smiles-List__item">🔼</li>
    <li class="Editor-Smiles-List__item">⏫</li>
    <li class="Editor-Smiles-List__item">🔽</li>
    <li class="Editor-Smiles-List__item">⏬</li>
    <li class="Editor-Smiles-List__item">⏸️</li>
    <li class="Editor-Smiles-List__item">⏹️</li>
    <li class="Editor-Smiles-List__item">⏺️</li>
    <li class="Editor-Smiles-List__item">⏏️</li>
    <li class="Editor-Smiles-List__item">🎦</li>
    <li class="Editor-Smiles-List__item">🔅</li>
    <li class="Editor-Smiles-List__item">🔆</li>
    <li class="Editor-Smiles-List__item">📶</li>
    <li class="Editor-Smiles-List__item">📳</li>
    <li class="Editor-Smiles-List__item">📴</li>
    <li class="Editor-Smiles-List__item">♀️</li>
    <li class="Editor-Smiles-List__item">♂️</li>
    <li class="Editor-Smiles-List__item">✖️</li>
    <li class="Editor-Smiles-List__item">➕</li>
    <li class="Editor-Smiles-List__item">➖</li>
    <li class="Editor-Smiles-List__item">➗</li>
    <li class="Editor-Smiles-List__item">♾️</li>
    <li class="Editor-Smiles-List__item">‼️</li>
    <li class="Editor-Smiles-List__item">⁉️</li>
    <li class="Editor-Smiles-List__item">❓</li>
    <li class="Editor-Smiles-List__item">❔</li>
    <li class="Editor-Smiles-List__item">❕</li>
    <li class="Editor-Smiles-List__item">❗</li>
    <li class="Editor-Smiles-List__item">💱</li>
    <li class="Editor-Smiles-List__item">💲</li>
    <li class="Editor-Smiles-List__item">⚕️</li>
    <li class="Editor-Smiles-List__item">♻️</li>
    <li class="Editor-Smiles-List__item">⚜️</li>
    <li class="Editor-Smiles-List__item">🔱</li>
    <li class="Editor-Smiles-List__item">📛</li>
    <li class="Editor-Smiles-List__item">🔰</li>
    <li class="Editor-Smiles-List__item">⭕</li>
    <li class="Editor-Smiles-List__item">✅</li>
    <li class="Editor-Smiles-List__item">☑️</li>
    <li class="Editor-Smiles-List__item">✔️</li>
    <li class="Editor-Smiles-List__item">❌</li>
    <li class="Editor-Smiles-List__item">❎</li>
    <li class="Editor-Smiles-List__item">➰</li>
    <li class="Editor-Smiles-List__item">➿</li>
    <li class="Editor-Smiles-List__item">〽️</li>
    <li class="Editor-Smiles-List__item">✳️</li>
    <li class="Editor-Smiles-List__item">✴️</li>
    <li class="Editor-Smiles-List__item">❇️</li>
    <li class="Editor-Smiles-List__item">©️</li>
    <li class="Editor-Smiles-List__item">®️</li>
    <li class="Editor-Smiles-List__item">™️</li>
    <li class="Editor-Smiles-List__item">#️⃣</li>
    <li class="Editor-Smiles-List__item">*️⃣</li>
    <li class="Editor-Smiles-List__item">0️⃣</li>
    <li class="Editor-Smiles-List__item">1️⃣</li>
    <li class="Editor-Smiles-List__item">2️⃣</li>
    <li class="Editor-Smiles-List__item">3️⃣</li>
    <li class="Editor-Smiles-List__item">4️⃣</li>
    <li class="Editor-Smiles-List__item">5️⃣</li>
    <li class="Editor-Smiles-List__item">6️⃣</li>
    <li class="Editor-Smiles-List__item">7️⃣</li>
    <li class="Editor-Smiles-List__item">8️⃣</li>
    <li class="Editor-Smiles-List__item">9️⃣</li>
    <li class="Editor-Smiles-List__item">🔟</li>
    <li class="Editor-Smiles-List__item">🔴</li>
    <li class="Editor-Smiles-List__item">🟠</li>
    <li class="Editor-Smiles-List__item">🟡</li>
    <li class="Editor-Smiles-List__item">🟤</li>
    <li class="Editor-Smiles-List__item">🔵</li>
    <li class="Editor-Smiles-List__item">🟢</li>
    <li class="Editor-Smiles-List__item">🟣</li>
    <li class="Editor-Smiles-List__item">⚫</li>
    <li class="Editor-Smiles-List__item">⚪</li>
    <li class="Editor-Smiles-List__item">🟥</li>
    <li class="Editor-Smiles-List__item">🟧</li>
    <li class="Editor-Smiles-List__item">🟨</li>
    <li class="Editor-Smiles-List__item">🟫</li>
    <li class="Editor-Smiles-List__item">🟦</li>
    <li class="Editor-Smiles-List__item">🟩</li>
    <li class="Editor-Smiles-List__item">🟪</li>
    <li class="Editor-Smiles-List__item">⬛</li>
    <li class="Editor-Smiles-List__item">⬜</li>
  </ul>
</template>

